// Splash "6A · 1b Pulso": the static copy in index.html paints the first frame.

const MIN_VISIBLE_MS = 600;
const FADE_MS = 250;
const startedAt = performance.now();

/** Fades out the index.html splash, keeping it on screen at least 600 ms so a
 *  fast boot doesn't flash it. Safe to call more than once. */
export function hideSplash() {
  const el = document.getElementById('gromly-splash');
  if (!el || el.dataset.hiding) return;
  el.dataset.hiding = 'true';
  const wait = Math.max(0, MIN_VISIBLE_MS - (performance.now() - startedAt));
  window.setTimeout(() => {
    el.classList.add('is-hidden');
    // transitionend never fires with reduced motion or a hidden tab.
    window.setTimeout(() => el.remove(), FADE_MS + 150);
  }, wait);
}
